import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import SettlementLinkedTable from "./components/SettlementLinkedTable";
import ConversionHistoryTable from "./components/ConversionHistoryTable";
import { useMerchantConversionHistory, useConsumerConversionHistory } from "./hooks/useTreasury";

const TABS = [
  { key: "settlement", label: "Settlement-Linked" },
  { key: "merchant", label: "Merchant History" },
  { key: "consumer", label: "Consumer History" },
];

const ConversionLogPage = () => {
  const [activeTab, setActiveTab] = useState("settlement");

  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Treasury: Conversion Log</h1>

        <div className="flex gap-2 mb-6 border-b border-gray-200">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 text-sm font-semibold border-b-2 transition-colors ${
                activeTab === tab.key
                  ? "border-emerald-600 text-emerald-700"
                  : "border-transparent text-gray-500 hover:text-gray-800"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "settlement" && <SettlementLinkedTable />}

        {activeTab === "merchant" && (
          <ConversionHistoryTable
            useHistory={useMerchantConversionHistory}
            subjectLabel="Business"
            subjectAccessor={(row) => row.business?.name}
            emptyMessage="No merchant conversions match the current filters yet."
          />
        )}

        {activeTab === "consumer" && (
          <ConversionHistoryTable
            useHistory={useConsumerConversionHistory}
            subjectLabel="User"
            subjectAccessor={(row) => row.user?.email}
            emptyMessage="No consumer conversions match the current filters yet."
          />
        )}
      </div>
    </div>
  );
};

export default ConversionLogPage;
